module.exports = __webpack_public_path__ + "static/media/cp7in.b0eab7fc.png";